import service from './api.services';

const listarMonitoramento = async (filtro) => {
    const response = await service.get('api/monitoramento/idprocesso', {
        params: { ...filtro, pagina: filtro.pagina - 1 },
    });
    return response.data;
};

const listarMonitoramentoAll = async (filtro) => {
    const pagina = filtro.pagina && filtro.pagina > 0 ? filtro.pagina - 1 : 0;
    const response = await service.get('api/monitoramento', {
        params: { ...filtro, pagina },
    });
    return response.data;
};

const downloadRecibo = async (monitoramentoId) => {
    const response = await service.post(
        `api/monitoramento/download/${monitoramentoId}`,
        null, // corpo da requisição, vazio porque não precisa enviar dados extras
        {
            responseType: 'blob', // configura o Axios para interpretar a resposta como binário
        }
    );

    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `recibo_${monitoramentoId}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
};

const obterReciboBlob = async (monitoramentoId) => {
    const response = await service.post(`api/monitoramento/download/${monitoramentoId}`, null, {
        responseType: 'blob',
    });

    return new Blob([response.data], { type: 'application/pdf' });
};
const downloadRelatorioMonitoramentos = async (listaMonitoramentos) => {
    if (!Array.isArray(listaMonitoramentos) || listaMonitoramentos.length === 0) {
        throw new Error('A lista de monitoramentos não pode ser vazia');
    }

    const response = await service.post('api/monitoramento/relatorio/monitoramento', listaMonitoramentos, {
        responseType: 'blob',
    });

    const contentType = response.headers['content-type'];

    // Verifica se o conteúdo retornado é um Excel
    const isExcel = contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    // Define o nome do arquivo com base no tipo
    const nomeArquivo = isExcel ? 'relatorio_monitoramento.xlsx' : 'relatorio_monitoramento_desconhecido';

    const blob = new Blob([response.data], { type: contentType });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nomeArquivo);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

const downloadArquivoFotoParcelasV2 = async (idArquivo, codigoImovel) => {
    return await service.get(`api/monitoramento/foto/parcelas/${idArquivo}/${codigoImovel}`, {
        responseType: 'blob',
    });
};

const buscarSalvoPorIdMonitoramento = async (idMonitoramento, codigoImovel) => {
    const response = await service.get(`api/monitoramento/foto/parcelas/buscar/${idMonitoramento}/${codigoImovel}`);
    return response.data;
};

const buscarHistoricoAreaMonitoramento = async (idArea) => {
    const response = await service.get(`api/monitoramento/historico/area/${idArea}`);
    return response.data;
};

const buscarArquivoKML = async (idArquivo, codImovel) => {
    return await service.get(`/api/monitoramento/download-kml/${idArquivo}/${codImovel}`, null, {
        responseType: 'blob',
    });
};

const buscarDadosModalValidacao = async (idMonitoramento) => {
    const response = await service.get(`api/validacao-monitoramento/dados-modal/${idMonitoramento}`);
    return response.data;
};

const buscarTecnicosParaVinculacao = async () => {
    const response = await service.get('api/validacao-monitoramento/tecnicos-para-vinculacao');
    return response.data;
};

const finalizarValidacao = async (payload) => {
    const response = await service.post('api/validacao-monitoramento/finalizar', payload);
    return response.data;
};

const enviarNotificacao = async (idMonitoramento, codigoImovel) => {
    const response = await service.post(`api/monitoramento/enviar/notificacao/${idMonitoramento}/${codigoImovel}`);
    return response.data;
};

const baixarPdfNotificacaoVencida = async (monitoramentoId, numeroNotificacao) => {
    const response = await service.post(
        `api/monitoramento/download/notificacao/${monitoramentoId}`,
        null,
        {
            responseType: 'blob',
        }
    );

    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `notificacao_${numeroNotificacao}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
};

export {
    listarMonitoramento,
    listarMonitoramentoAll,
    downloadRecibo,
    obterReciboBlob,
    downloadRelatorioMonitoramentos,
    downloadArquivoFotoParcelasV2,
    buscarSalvoPorIdMonitoramento,
    buscarArquivoKML,
    buscarHistoricoAreaMonitoramento,
    buscarDadosModalValidacao,
    buscarTecnicosParaVinculacao,
    finalizarValidacao,
    enviarNotificacao,
    baixarPdfNotificacaoVencida
};
